import axios from "@/plugins/axios";

let url = "/api/v1/person/attendance/codes";

export const codes = {
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default codes;
